(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeAvoirDetailController', TypeAvoirDetailController);

    TypeAvoirDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TypeAvoir'];

    function TypeAvoirDetailController($scope, $rootScope, $stateParams, entity, TypeAvoir) {
        var vm = this;
        vm.typeAvoir = entity;
        vm.load = function (id) {
            TypeAvoir.get({id: id}, function(result) {
                vm.typeAvoir = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:typeAvoirUpdate', function(event, result) {
            vm.typeAvoir = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
